import { useFormik } from "formik"
import { TApiTaskComment } from "../../api-client/types"
import { useCreateCommentMutation } from "./use-create-comment-mutation"

interface TaskCommentFormObject extends Partial<TApiTaskComment> {}

interface Props extends Partial<ReturnType<typeof useFormik<TaskCommentFormObject>>>{
  projectId: string

  onSuccess?(): any
  onError?(): any
}

const DEFAULT_VALUES = {
  taskId: '',
  content: '',
}

export const useCommentFormik = (props: Props) => {
  const {
    projectId,
    onSuccess,
    onError,
    ...formikProps
  } = props

  const createCommentMutation = useCreateCommentMutation({
    projectId
  })

  const formik = useFormik<TaskCommentFormObject>({
    initialValues: {
      ...DEFAULT_VALUES,
      ...formikProps.initialValues,
    },
    onSubmit: async (values) => {
      return createCommentMutation.mutateAsync({
        taskId: values.taskId,
        content: values.content
      }, {
        onSuccess,
        onError,
      })
    }
  })

  return formik
}